export const LOGIN = '/login';
export const MANAGE_GARAGE = '/manage-garage';
export const PATH_HOME = '/';
export const PATH_AUTH_LOGIN = '/auth/login';
export const PATH_AUTH_FORGOT_PASSWORD = '/auth/forgot-password';
